// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Formality = require("re-formality/src/Formality.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var WebTypes_View = require("../../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebGraphql_Login = require("../../graphql/WebGraphql_Login.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Form = require("../../../../shared-browser/src/components/BrowserComponents_Form.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var Formality__ReactUpdate = require("re-formality/src/Formality__ReactUpdate.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserFormalityHelpers = require("../../../../shared-browser/src/BrowserFormalityHelpers.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_Loading = require("../../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var WebComponents_SimpleCenteredLogoPage = require("../../components/WebComponents_SimpleCenteredLogoPage.bs.js");

var validators_password = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param) {
      return BrowserFormalityHelpers.Validators.nonWhitespace(param.password);
    })
};

var validators_confirmPassword = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param) {
      var confirmPassword = param.confirmPassword;
      if (confirmPassword === "") {
        return Relude_Result.error("Required");
      }
      var password = param.password;
      if (password === "" || Relude_String.eq(confirmPassword, password)) {
        return Relude_Result.ok(confirmPassword);
      } else {
        return Relude_Result.error("Passwords do not match");
      }
    })
};

var validators = {
  password: validators_password,
  confirmPassword: validators_confirmPassword
};

function initialFieldsStatuses(_input) {
  return {
          password: /* Pristine */0,
          confirmPassword: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            password: /* Pristine */0,
            confirmPassword: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.password;
  var match_0 = match ? match._0 : Curry._1(validators.password.validate, input);
  var match$1 = fieldsStatuses.confirmPassword;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.confirmPassword.validate, input);
  var passwordResult = match_0;
  var passwordResult$1;
  if (passwordResult.TAG === /* Ok */0) {
    var confirmPasswordResult = match_0$1;
    if (confirmPasswordResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                confirmPassword: confirmPasswordResult._0,
                password: passwordResult._0
              },
              fieldsStatuses: {
                password: /* Dirty */{
                  _0: passwordResult,
                  _1: /* Shown */0
                },
                confirmPassword: /* Dirty */{
                  _0: confirmPasswordResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    passwordResult$1 = passwordResult;
  } else {
    passwordResult$1 = passwordResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            password: /* Dirty */{
              _0: passwordResult$1,
              _1: /* Shown */0
            },
            confirmPassword: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurPasswordField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.password, validators_password, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  password: status,
                                  confirmPassword: init.confirmPassword
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurConfirmPasswordField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.confirmPassword, validators_confirmPassword, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  password: init.password,
                                  confirmPassword: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdatePasswordField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$2 = Formality.validateDependentFieldOnChange(nextInput, nextFieldsStatuses.contents.confirmPassword, validators_confirmPassword, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  password: init.password,
                                  confirmPassword: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    nextFieldsStatuses.contents = result$2;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, nextFieldsStatuses.contents.password, state.submissionStatus, validators_password, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            password: status,
                                            confirmPassword: init.confirmPassword
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateConfirmPasswordField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$3 = Formality.validateDependentFieldOnChange(nextInput$1, nextFieldsStatuses$1.contents.password, validators_password, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  password: status,
                                  confirmPassword: init.confirmPassword
                                };
                        }));
                  if (result$3 !== undefined) {
                    nextFieldsStatuses$1.contents = result$3;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, nextFieldsStatuses$1.contents.confirmPassword, state.submissionStatus, validators_confirmPassword, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            password: init.password,
                                            confirmPassword: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                password: /* Pristine */0,
                                confirmPassword: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                password: /* Pristine */0,
                                confirmPassword: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updatePassword: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePasswordField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateConfirmPassword: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateConfirmPasswordField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurPassword: (function (param) {
              return Curry._1(dispatch, /* BlurPasswordField */0);
            }),
          blurConfirmPassword: (function (param) {
              return Curry._1(dispatch, /* BlurConfirmPasswordField */1);
            }),
          passwordResult: Formality.exposeFieldResult(state.fieldsStatuses.password),
          confirmPasswordResult: Formality.exposeFieldResult(state.fieldsStatuses.confirmPassword),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.password || match.confirmPassword) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Internal = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var FormFields = {
  Internal: Internal,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getFormError(param) {
  return Relude_Globals.$great$great((function (submissionError) {
                if (typeof submissionError === "number") {
                  return ;
                } else if (submissionError.TAG === /* Submitting */0) {
                  return submissionError._0;
                } else {
                  return Relude_Option.pure(submissionError._0);
                }
              }), (function (param) {
                return Relude_Option.map((function (param) {
                              return "Your password could not be reset due to a system error";
                            }), param);
              }), param);
}

var text = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.textAlign(BrowserStyle.center),
          tl: /* [] */0
        }));

var errorMessage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Red */5,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var image = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

var Styles = {
  text: text,
  errorMessage: errorMessage,
  image: image
};

function WebContainers_Login_ResetPassword$Presentation(Props) {
  var client = Props.client;
  var resetToken = Props.resetToken;
  var setView = Props.setView;
  var match = ReactIO.useState(function (param) {
        return /* Init */0;
      });
  var setValidResetToken = match[1];
  var match$1 = useForm({
        confirmPassword: "",
        password: ""
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var partial_arg = Curry._1(param$1.notifyOnSuccess, undefined);
          var partial_arg$1 = function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          };
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold((function (param) {
                                      return Relude_Globals.$great$great((function (param) {
                                                    return Relude_Globals.$$const(/* CouldNotResetPassword */0, param);
                                                  }), notifyOnFailure, param);
                                    }), partial_arg$1, param);
                      }), Curry._2(WebGraphql_Login.ResetPassword.mutateResult, {
                          password: param.password,
                          token: resetToken
                        }, client));
        }));
  var status = match$1.status;
  var match$2 = match$1.input;
  var password = match$2.password;
  var confirmPassword = match$2.confirmPassword;
  var confirmPasswordResult = match$1.confirmPasswordResult;
  var passwordResult = match$1.passwordResult;
  var blurConfirmPassword = match$1.blurConfirmPassword;
  var blurPassword = match$1.blurPassword;
  var updateConfirmPassword = match$1.updateConfirmPassword;
  var updatePassword = match$1.updatePassword;
  var updateConfirmPassword$1 = function (confirmPassword) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateConfirmPassword, (function (input, confirmPassword) {
                              return {
                                      confirmPassword: confirmPassword,
                                      password: input.password
                                    };
                            }), confirmPassword);
              });
  };
  var updatePassword$1 = function (password) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updatePassword, (function (input, password) {
                              return {
                                      confirmPassword: input.confirmPassword,
                                      password: password
                                    };
                            }), password);
              });
  };
  var onSubmit = Relude_IO.suspend(match$1.submit);
  ReactIO.useEffect1(undefined, undefined, (function (resetToken) {
          return Relude_IO.flatMap((function (param) {
                        return Relude_IO.flatMap(setValidResetToken, Curry._2(Relude_IO.mapError, (function (prim) {
                                          
                                        }), Curry._2(WebGraphql_Login.ValidateResetToken.mutateAsyncResult, resetToken, client)));
                      }), Curry._1(setValidResetToken, /* Init */0));
        }), resetToken);
  return Relude_AsyncResult.foldByValue(React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
                  children: React.createElement(BrowserComponents_Loading.make, {}),
                  title: "Reset Password"
                }), (function (param) {
                if (typeof status === "number" && status !== 0) {
                  return React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
                              children: null,
                              subtitle: "Your password has been reset!",
                              title: "Password Reset Successfully"
                            }, React.createElement(BrowserComponents_Image.make, {
                                  className: image,
                                  image: {
                                    TAG: /* Illustration */1,
                                    _0: /* Keyboard */47
                                  }
                                }), React.createElement(BrowserComponents_Spacer.make, {
                                  size: /* XLarge */6
                                }), React.createElement(BrowserComponents_Button.make, {
                                  actionPriority: /* Primary */0,
                                  onClick: (function (param) {
                                      return Curry._1(setView, {
                                                  TAG: /* Login */3,
                                                  _0: /* Business */0
                                                });
                                    }),
                                  size: /* Large */2,
                                  title: "LOG IN"
                                }));
                }
                return React.createElement(BrowserComponents_Form.make, {
                            onSubmit: onSubmit,
                            children: React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
                                  children: null,
                                  title: "Reset Password"
                                }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(passwordResult)("newPassword", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "password", Relude_IO.suspend(blurPassword), undefined, undefined, undefined, undefined, undefined, "passwordInput", undefined, "Password", undefined, undefined, undefined, undefined), {
                                          TAG: /* Password */6,
                                          _0: {
                                            onChange: updatePassword$1,
                                            value: password
                                          }
                                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* Medium */4
                                    }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(confirmPasswordResult)("newPassword", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "confirm_password", Relude_IO.suspend(blurConfirmPassword), undefined, undefined, undefined, undefined, undefined, "confirmPasswordInput", undefined, "Confirm Password", undefined, undefined, undefined, undefined), {
                                          TAG: /* Password */6,
                                          _0: {
                                            onChange: updateConfirmPassword$1,
                                            value: confirmPassword
                                          }
                                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* Large */5
                                    }), Relude_Option.fold(null, (function (error) {
                                        return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, {
                                                        className: errorMessage,
                                                        children: error
                                                      }), React.createElement(BrowserComponents_Spacer.make, {
                                                        size: /* Large */5
                                                      }));
                                      }), getFormError(status)), React.createElement(BrowserComponents_Button.make, {
                                      actionPriority: /* Primary */0,
                                      onClick: (function (param) {
                                          return Relude_IO.pure(undefined);
                                        }),
                                      size: /* Large */2,
                                      testId: "submitButton",
                                      title: "RESET",
                                      type_: "submit"
                                    }), React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* XXLarge */7
                                    }), React.createElement("a", {
                                      href: WebTypes_View.toHref({
                                            TAG: /* Login */3,
                                            _0: /* Business */0
                                          })
                                    }, React.createElement(BrowserComponents_Text.make, {
                                          className: text,
                                          children: "Log In"
                                        })))
                          });
              }), (function (param) {
                return React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
                            children: null,
                            subtitle: "This reset password link has expired. Please request a new one.",
                            title: "Reset Password"
                          }, React.createElement(BrowserComponents_Image.make, {
                                className: image,
                                image: {
                                  TAG: /* Illustration */1,
                                  _0: /* CalendarTargetExclamationRed */10
                                }
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* XLarge */6
                              }), React.createElement(BrowserComponents_Button.make, {
                                actionPriority: /* Primary */0,
                                onClick: (function (param) {
                                    return Curry._1(setView, {
                                                TAG: /* Login */3,
                                                _0: /* ForgotPassword */1
                                              });
                                  }),
                                size: /* Large */2,
                                title: "FORGOT PASSWORD"
                              }));
              }), match[0]);
}

var Presentation = {
  FormFields: FormFields,
  getFormError: getFormError,
  Styles: Styles,
  make: WebContainers_Login_ResetPassword$Presentation
};

var mapStateToProps = Reselect.createSelector1(undefined, WebStore_Selectors.getApolloClient, Relude_Globals.id);

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = {
    setView: (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                    }), partial_arg, param);
      })
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$1, param);
  };
}

function WebContainers_Login_ResetPassword(Props) {
  var resetToken = Props.resetToken;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (client, param) {
                  return React.createElement(WebContainers_Login_ResetPassword$Presentation, {
                              client: client,
                              resetToken: resetToken,
                              setView: param.setView
                            });
                })
            });
}

var make = WebContainers_Login_ResetPassword;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* text Not a pure module */
